import {
  Card,
  CircularProgress,
  Divider,
  Stack,
  styled,
  Typography,
} from '@mui/material';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(2),
}));

export const StyledAppsContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(2),
}));

export const StyledLoader = styled(CircularProgress)({
  alignSelf: 'center',
  color: '#6D77C8',
});

export const StyledDivider = styled(Divider)({
  color: '#e2e8f0',
});

export const StyledCreateAppContainer = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const StyledCreateAppTitle = styled(Typography)({
  fontFamily: '"Inter", sans-serif',
});
